export const skeletonLoaderHeight = '--skeleton-loader-height';
export const skeletonLoaderWidth = '--skeleton-loader-width';
export const dataTableResponsiveBreakpoint = 576;
export const mouseEnter = 'mouseenter';
